// extracted by mini-css-extract-plugin
export default {"zoomControls":"Saa-z","zoomControlButton":"Taa-z","zoomBanner":"Uaa-z","bannerButton":"Vaa-z","imageButton":"Waa-z","zoom":"Xaa-z","zoomContent":"Yaa-z"};